"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RtcCommand_1 = require("../Engine/Command/RtcCommand");
class ChatCommand {
    static FetchInitialChatsCommand(allChatIdAndLastCm) {
        return RtcCommand_1.RtcCommand.Builder()
            .AutoId()
            .Category(ChatCommand.Category)
            .Name(ChatCommand.FetchInitialChats)
            .CmdTypeAction(RtcCommand_1.CmdType.RequestExecute)
            .IsToService(true)
            .Content(allChatIdAndLastCm)
            .Build();
    }
    static FetchInitialChatsResponseAcceptCommand(initChats, receiver, reqCmdId) {
        const rtcCmdbuilder = RtcCommand_1.RtcCommand.Builder()
            .AutoId()
            .Category(ChatCommand.Category)
            .Name(ChatCommand.FetchInitialChats)
            .CmdTypeAction(RtcCommand_1.CmdType.ResponseAccept)
            .AddReceiver(receiver)
            .Content(initChats);
        if (reqCmdId)
            rtcCmdbuilder.Id(reqCmdId);
        return rtcCmdbuilder.Build();
    }
    static QueryNewChatMessagesCommand(allChatIdTotalMsgCount) {
        return RtcCommand_1.RtcCommand.Builder()
            .AutoId()
            .Name(ChatCommand.QueryNewChatMessages)
            .CmdTypeAction(RtcCommand_1.CmdType.RequestExecute)
            .Category(ChatCommand.Category)
            .IsToService(true)
            .Content(allChatIdTotalMsgCount)
            .Build();
    }
    static QueryNewChatMessagesResponseAcceptCommand(rtcCmd, allChatIdCmsTotalMsgCount) {
        return RtcCommand_1.RtcCommand.Builder()
            .Id(rtcCmd.id)
            .CmdTypeAction(RtcCommand_1.CmdType.ResponseAccept)
            .Category(rtcCmd.category)
            .Name(rtcCmd.name)
            .AddReceiver(rtcCmd.sender)
            .Content(allChatIdCmsTotalMsgCount)
            .Build();
    }
    static UpdateParticipantReadCountCommand(chatId, chatIdUsernameMsgCount) {
        return RtcCommand_1.RtcCommand.Builder()
            .AutoId()
            .Name(ChatCommand.UpdateParticipantReadCount)
            .CmdTypeAction(RtcCommand_1.CmdType.RequestExecute)
            .Category(ChatCommand.Category)
            .IsToService(true)
            .TargetId(chatId)
            .Content(chatIdUsernameMsgCount)
            .Build();
    }
    static ChatMessagesBeforeCommand(chatId, refCmDtoAndCount) {
        return RtcCommand_1.RtcCommand.Builder()
            .AutoId()
            .Category(ChatCommand.Category)
            .Name(ChatCommand.ChatMessagesBefore)
            .CmdTypeAction(RtcCommand_1.CmdType.RequestExecute)
            .IsToService(true)
            .TargetId(chatId)
            .Content(refCmDtoAndCount)
            .Build();
    }
    static ChatMessagesBeforeResponseAcceptCommand(rtcCmd, cmDtosAndQueryMsgCount) {
        return RtcCommand_1.RtcCommand.Builder(rtcCmd)
            .Category(ChatCommand.Category)
            .Name(ChatCommand.ChatMessagesBefore)
            .CmdTypeAction(RtcCommand_1.CmdType.ResponseAccept)
            .Sender("*")
            .AddReceiver(rtcCmd.sender)
            .Content(cmDtosAndQueryMsgCount)
            .Build();
    }
    static ParticipantSpeakCommand(chatId, cmDtos) {
        return RtcCommand_1.RtcCommand.Builder()
            .AutoId()
            .Category(ChatCommand.Category)
            .Name(ChatCommand.ParticipantSpeak)
            .CmdTypeAction(RtcCommand_1.CmdType.RequestExecute)
            .IsToService(true)
            .TargetId(chatId)
            .Content(cmDtos)
            .Build();
    }
    static RequestChatCommand(chatDto, cmdType = RtcCommand_1.CmdType.RequestExecute) {
        return RtcCommand_1.RtcCommand.Builder()
            .AutoId()
            .Category(ChatCommand.Category)
            .Name(ChatCommand.RequestChat)
            .CmdTypeAction(cmdType)
            .IsToService(true)
            .Content(chatDto)
            .Build();
    }
}
ChatCommand.Category = "Chat";
ChatCommand.FetchInitialChats = "FetchInitialChats";
ChatCommand.QueryNewChatMessages = "QueryNewChatMessages";
ChatCommand.UpdateParticipantReadCount = "UpdateParticipantReadCount";
ChatCommand.ChatMessagesBefore = "ChatMessagesBefore";
ChatCommand.ParticipantSpeak = "ParticipantSpeak";
ChatCommand.RequestChat = "RequestChat";
// Attachment related
ChatCommand.UploadAttachment = "UploadAttachment";
ChatCommand.QueryAttachmentStatus = "QueryAttachmentStatus";
ChatCommand.DownloadAttachment = "DownloadAttachment";
exports.ChatCommand = ChatCommand;
//# sourceMappingURL=ChatCommand.js.map